import { Language } from '@/siteBuilder/locale'
/**
 * Function to extract  language from contentful locale
 * @param  {Entry<unknown>} entry contentful entry
 *
 * @returns Language
 *
 * @example
 * // returns "en"
 * getLangFromContentfulLocale('en-CA-AB')
 *
 * @example
 * // returns "fr"
 * getLangFromContentfulLocale('fr-CA')
 */
export const getLangFromContentfulLocale = (entry: { sys?: { locale?: string } }) =>
  (entry.sys?.locale?.split('-')[0] || 'en') as Language
